import { getReportParams, report } from '../../../middleware/report';

export const abroadInsuranceCreateReportFromTracker = (status, msg, expireDate, customerName, ban, subscriber, id) => {

  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'My Zone';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = status;
  reportParams.actionType = 'Tracker Message';
  reportParams.messageText = msg;
  reportParams.param1 = expireDate;
  reportParams.customerName = customerName;
  reportParams.banId = ban;
  reportParams.subscriber = subscriber;
  reportParams.idNumber = id;
  report(reportParams);
};

export const abroadInsuranceCreateReportShowDetails = (channel, status, msg, expireDate, customerName, ban, subscriber, id) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.status = status;
  reportParams.actionType = 'Package Exists';
  reportParams.messageText = msg;
  reportParams.param1 = expireDate;
  reportParams.customerName = customerName;
  reportParams.banId = ban;
  reportParams.subscriber = subscriber;
  reportParams.idNumber = id;
  report(reportParams);
};

export const abroadInsuranceCreateReportShowBannerAfterAbroadSale = (status, msg, customerName, ban, subscriber, id) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = status;
  reportParams.actionType = 'Abroad Success Page';
  reportParams.messageText = msg;
  reportParams.customerName = customerName;
  reportParams.banId = ban;
  reportParams.subscriber = subscriber;
  reportParams.idNumber = id;
  report(reportParams);
};

export const abroadInsuranceOtpReport = (status, msg , subscriber,actionType) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Insurance Page';
  reportParams.channel = 'WebsitePrivate';
  reportParams.status = status;
  reportParams.actionType = actionType;
  reportParams.messageText = msg;
  reportParams.customerName = '';
  reportParams.banId = '';
  reportParams.subscriber = subscriber;
  reportParams.idNumber = '';
  report(reportParams);
};